import { Button } from 'tradera/components/atoms/button/button';
import { Text } from 'tradera/components/atoms/text/text';
import { useTranslator, useUrlLocalizer } from 'tradera/lang/translate';
import { type PublicMember } from 'tradera/state/services/types/webapi-mytradera-generated';
import { ItemType as ItemTypeEnum } from 'tradera/state/services/types/webapi-mytradera-generated';

type ItemTypeProps = {
    itemType?: string;
    bidCount?: number;
    itemId?: number;
    onShowBidHistory?: (itemId: number) => void;
    leadingBidder?: PublicMember | null;
};

export const ItemType = ({
    itemType,
    bidCount,
    itemId,
    onShowBidHistory,
    leadingBidder
}: ItemTypeProps) => {
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();
    const hasBids = bidCount && bidCount > 0;
    const highestBidderUrl = toLocalizedUrl(
        `/profile/items/${leadingBidder?.id}/${leadingBidder?.alias}`
    );

    return (
        <div>
            {itemType === ItemTypeEnum.PureBin ||
            itemType === ItemTypeEnum.Shopitem ? (
                <Text>{t('myt_columns_buyNow')}</Text>
            ) : null}
            {itemType === ItemTypeEnum.Auction ||
            itemType === ItemTypeEnum.AuctionBin ? (
                onShowBidHistory && itemId && hasBids ? (
                    <div className="d-flex gap-1">
                        <Button
                            theme="link"
                            onClick={() => {
                                onShowBidHistory(itemId);
                            }}>
                            {t('myt_listItem_numberOfBidsWithCount', {
                                count: bidCount
                            })}
                        </Button>
                        {leadingBidder && (
                            <div className="d-none d-md-inline">
                                •
                                <Button
                                    theme="link"
                                    className="ml-1"
                                    href={highestBidderUrl}>
                                    {leadingBidder.alias}
                                </Button>
                            </div>
                        )}
                    </div>
                ) : (
                    <Text as="span">
                        {t('myt_listItem_numberOfBidsWithCount', {
                            count: bidCount
                        })}
                    </Text>
                )
            ) : null}
            {itemType === ItemTypeEnum.AuctionBin && !hasBids ? (
                <Text as="span">/{t('myt_columns_buyNow')}</Text>
            ) : null}
        </div>
    );
};
